module.exports = __webpack_public_path__ + "static/media/secondary.49377588.JPG";